import BreadCrumb from './breadcrumb'

export default BreadCrumb
